import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Company } from '../../../services/company.service';
import { CompanyContextService } from '../../../services/company-context.service';
import { CompanyAdminImpersonationService } from '../../../impersonation/services/company-admin-impersonation.service';
import { ImpersonationConfirmModalComponent } from '../../../../shared/components/impersonation-confirm-modal';

/**
 * Impersonate this company's admin account. The company is already chosen by the
 * route, so this only has to name the admin and confirm.
 */
@Component({
  selector: 'app-company-impersonate-admin',
  standalone: true,
  imports: [CommonModule, ImpersonationConfirmModalComponent],
  templateUrl: './company-impersonate-admin.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./company-impersonate-admin.component.scss'],
})
export class CompanyImpersonateAdminComponent {
  private readonly launcher = inject(CompanyAdminImpersonationService);
  readonly context = inject(CompanyContextService);

  confirmVisible = false;

  get company(): Company | null {
    return this.context.current;
  }

  get busy(): boolean {
    return this.launcher.busyCompanyId === this.company?.id;
  }

  get canImpersonate(): boolean {
    return this.launcher.canImpersonate(this.company);
  }

  get adminLabel(): string {
    return this.launcher.adminLabel(this.company);
  }

  openConfirm(): void {
    if (!this.canImpersonate) {
      this.launcher.warnMissingAdminId();
      return;
    }
    this.confirmVisible = true;
  }

  closeConfirm(): void {
    if (this.busy) {
      return;
    }
    this.confirmVisible = false;
  }

  onConfirmImpersonate(): void {
    const company = this.company;
    if (!company || this.busy) {
      return;
    }
    this.launcher.start(company, () => {
      this.confirmVisible = false;
    });
  }
}
